exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".transactions-table .md-table-cell:last-of-type,.transactions-table .md-table-head:last-of-type{width:255px;text-align:center}.transactions .error{font-size:22px;margin:100px 0 50px;text-align:center;color:rgba(0,0,0,.87);font-weight:400}.stornoInput{resize:none;height:150px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-55149734","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Admin/Transactions.vue
// module id = 376
// module chunks = 0